// limited promotions, based on dynamic rules from api
export const PROMO_ID_BLACK_WEEKEND = '9ed97e13-57ba-464f-ae71-85156c0ee969'
export const PROMO_ID_BIRTHDAY = '3e55d695-72a4-4a9b-8c14-6eecf36dc995'
export const PROMO_ID_SUMMER_SALE = '3f5344de-0006-4353-8812-ac7944a91e1a'

// auto promotions, based on promotion codes and/or fulfilling specific rules
export const PROMO_NAME_MARCH = 'March Promotion'
export const PROMO_NAME_CITY_BREAK = 'City break'
export const PROMO_NAME_SV79 = 'Suntago Village 79'
export const PROMO_ID_SV79 = '3918bacb-7633-44b4-b64e-14c2b99100d1'
